/**
 * For rss.app's carousel component
 * 
 */

const target = document.querySelector('rssapp-carousel');
if (target) {
    setTimeout(() => {
        injectStyles(target.shadowRoot);
        // Function to inject styles into the Shadow DOM
    }, 2500);
    
    const injectStyles = (shadowRoot) => {
        const style = document.createElement('style');
        style.textContent = `
        .rssapp-carousel-container {
            .rssapp-card {
                background-color: var(--white) !important;
            }
            .rssapp-card-title {
                color: var(--black) !important;
                a {
                    color: var(--black) !important;
                }
                span {
                    color: var(--black) !important;
                }
            }
            .rssapp-card-description {
                color: var(--black) !important;
            }
            .rssapp-card-footer {
                color: var(--black) !important;
            }
        }
        `;
        shadowRoot.appendChild(style);
    };
}